module.exports = __webpack_public_path__ + "static/media/aplicatie-libera.92eeea25.jpg";